import React from 'react';
import { Box, Typography, Button, Grid, useTheme, useMediaQuery } from '@mui/material';
import '../styling/styling.css'

const PHONE = '270-577-5067';

const heroStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    color: 'white',
    marginTop: 0,
    minHeight: { xs: '30vh', sm: '4vh' },
};

const contentStyle = {
    width: '100%',
    maxWidth: '1100px',
    margin: '0 auto',
    padding: { xs: '0rem', sm: '2rem' },
    paddingBottom: { xs: '3rem', sm: '6rem' } // extra space before footer
};

const cardStyle = (theme) => ({
    background: 'linear-gradient(180deg, rgba(255,255,255,0.95), rgba(250,245,255,0.9))',
    borderRadius: 12,
    padding: '1rem',
    boxShadow: '0 6px 18px rgba(0,0,0,0.12)',
    border: `1px solid ${theme.palette.divider}`,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: { xs: '65%', sm: '325px' },
    width: '100%',
    margin: '0 auto'
});

const priceStyle = {
    fontFamily: 'Oswald',
    fontSize: '1.5rem',
    fontWeight: 700,
    color: '#7b2cbf'
};

const featureListStyle = {
    marginTop: '0.5rem',
    flex: 1, // allow features area to grow so footer aligns
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start'
};

const packages = [
    {
        id: 'jr',
        title: 'Jr Painter (6 & under)',
        price: '$25',
        features: ['8x10 canvas', '3 paint bottles', '1 hour in Wild Room']
    },
    {
        id: 'standard',
        title: 'Basic',
        price: '$30',
        features: ['9x12 canvas', '3 paint bottles', 'Basic Prep Station', '1 hour in Wild Room']
    },
    {
        id: 'premium',
        title: 'Premium',
        price: '$35',
        features: ['11x14 canvas', '4 paint bottles', 'Full Access to Prep & Spin Stations', '1 hour in Wild Room']
    },
    {
        id: 'vip',
        title: 'VIP',
        price: '$40',
        features: ['16x20 canvas', '4 paint bottles', 'Full Access to Prep & Spin Stations', '1 hour in Wild Room']
    }
];

function SplatterSessions() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box>
            <Box sx={{ ...heroStyle, width: '100%', boxSizing: 'border-box', py: { xs: 4, sm: 6 }, textAlign: 'center' }}>
                <h1 className='pageHeading' style={{ color: 'white', marginTop: 0, marginBottom: '0%', textAlign: 'center' }}>SPLATTER SESSIONS</h1>
                <h3 className='pageSubHeading' style={{ color: 'white', maxWidth: '70%', marginTop: '1rem', marginBottom: '1rem', marginLeft: 'auto', marginRight: 'auto', textAlign: 'center' }}>
                    Let your creativity run wild in the Wild Room — a fully immersive splatter paint experience for
                    all ages and skill levels.
                </h3>
            </Box>

            <Box sx={contentStyle}>
                <Box sx={{ mb: 2, textAlign: 'center' }}>
                    <Typography variant='h6' sx={{ fontFamily: 'Yeseva One' }}>Wild Room Packages</Typography>
                    <Typography sx={{ fontStyle: 'italic', mt: 1 }}>All packages include 1 hour in the Wild Room and basic protective gear (poncho, goggles, foot coverings, hair coverings, and gloves).</Typography>
                </Box>

                <Grid container spacing={2} rowSpacing={{ xs: 3, md: 2 }} sx={{ alignItems: 'stretch', justifyContent: { xs: 'center', md: 'flex-start' } }}>
                    {packages.map((pkg) => (
                        <Grid item xs={12} sm={6} md={3} key={pkg.id} sx={{ display: 'flex', justifyContent: 'center', mb: { xs: 3, md: 0 } }}>
                            <Box sx={cardStyle(theme)}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography sx={{ fontFamily: 'Oswald', fontSize: '1.2rem' }}>{pkg.title}</Typography>
                                    <Typography sx={priceStyle}>{pkg.price}</Typography>
                                </Box>
                                <Box sx={featureListStyle}>
                                    {pkg.features.map((f, i) => (
                                        <Typography key={i} sx={{ fontSize: '0.95rem' }}>• {f}</Typography>
                                    ))}
                                </Box>
                                <Box sx={{ mt: 1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 1 }}>
                                    <Button variant='outlined' href={`tel:${PHONE}`}>Book Now</Button>
                                </Box>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    );
}

export default SplatterSessions;